/**
 * 奖励相关工具函数
 */

/**
 * 每关基础金币（与后端 GainBaseCoinReward 一致，用于 donesubmit 提交 coin）
 * 前30关 2 或 3 枚交替，31关后 1 或 2 枚交替
 * @param {number} number - 关卡号
 * @returns {number} 基础金币数量
 */
export const getBaseCoin = (number) => {
    if (number <= 30) {
        return 2 + (number % 2);
    }
    return 1 + (number % 2);
};

/**
 * 根据悟空等级获取宝箱金币（等级越高，金币越多）
 * @param {Object} pet - 宠物信息对象
 * @returns {number} 金币数量
 */
export const getTreasureBoxCoin = (pet) => {
    // 获取悟空等级，默认1级
    const phase = pet?.garden_info?.PetInfo?.Phase || 1;
    
    // 根据等级设计金币范围
    // Phase 1-3: 基础阶段 (10-25)
    // Phase 4-6: 成长阶段 (25-40)
    // Phase 7-9: 进阶阶段 (40-60)
    // Phase 10-12: 顶级阶段 (60-85)
    let baseMin, baseMax;
    if (phase <= 3) {
        baseMin = 10;
        baseMax = 25;
    } else if (phase <= 6) {
        baseMin = 25;
        baseMax = 40;
    } else if (phase <= 9) {
        baseMin = 40;
        baseMax = 60;
    } else {
        baseMin = 60;
        baseMax = 85;
    }
    
    // 在范围内随机，但使用加权概率让高值更容易出现
    const random = Math.random();
    let coin;
    if (random < 0.3) {
        // 30% 概率：低值（baseMin 到 baseMin + 30%范围）
        const lowMax = baseMin + (baseMax - baseMin) * 0.3;
        coin = Math.floor(baseMin + Math.random() * (lowMax - baseMin));
    } else if (random < 0.7) {
        // 40% 概率：中值（30% 到 70%范围）
        const lowMax = baseMin + (baseMax - baseMin) * 0.3;
        const highMin = baseMin + (baseMax - baseMin) * 0.7;
        coin = Math.floor(lowMax + Math.random() * (highMin - lowMax));
    } else {
        // 30% 概率：高值（70% 到 baseMax）
        const highMin = baseMin + (baseMax - baseMin) * 0.7;
        coin = Math.floor(highMin + Math.random() * (baseMax - highMin));
    }
    
    // 确保是5的倍数，更整齐
    coin = Math.round(coin / 5) * 5;
    
    return Math.max(baseMin, Math.min(coin, baseMax));
};

/**
 * 500关终极大礼（大宝箱）金币：小宝箱的 2 倍 + 50，作为通关奖励
 */
export const getBigBoxCoin = (pet) => {
    return 50 + getTreasureBoxCoin(pet) * 2;
};
